import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const RequiredTrainingCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(1),
}));

export const TrainingNameField = styled(Box)(() => ({
  minWidth: '570px',
}));
